import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from './hooks/useGeneralTasksStore';
import { GeneralTasksFilters } from './types/generalTasksTypes';
import { MyGeneralTasks } from './myGeneralTasks';


export const MyGeneralTaskInternal = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const [initializedFilters, setInitializedFilters] = useState<boolean>(false);

  const customFiltersForBackOffice = {
    [GeneralTasksFilters.TASK_SCOPE]: [],
  }

  useEffect(() => {
    generalTasksStore.setCustomFilters(customFiltersForBackOffice);
    setInitializedFilters(true);

    return () => {
      generalTasksStore.setCustomFilters({});
    }
  }, []);

  return <>
    {initializedFilters ? <MyGeneralTasks /> : null}
  </>;
});
